module.exports = __webpack_public_path__ + "img/p1-info@2x.f8e6afca.jpg";